"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "38", height: "38", viewBox: "0 0 38 38", className: "Icon toolbar-list-on", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
            _react2.default.createElement("rect", { stroke: "#000", width: "36", height: "36", rx: "3", strokeWidth: "2" }),
            _react2.default.createElement("path", { d: "M10 13a2 2 0 1 0 0-4 2 2 0 0 0 0 4z", fill: "#4C4C4C" }),
            _react2.default.createElement("circle", { fill: "#4C4C4C", cx: "10", cy: "18", r: "2" }),
            _react2.default.createElement("circle", { fill: "#4C4C4C", cx: "10", cy: "25", r: "2" }),
            _react2.default.createElement("path", { fill: "#4C4C4C", d: "M16 10h12v2H16zM16 17h12v2H16zM16 24h12v2H16z" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/large/jsx/toolbar-list-on.js
// module id = 1844
// module chunks = 0